import { render, staticRenderFns } from "./CheckListConfiguration.vue?vue&type=template&id=a9a44be2"
import script from "./CheckListConfiguration.vue?vue&type=script&lang=ts"
export * from "./CheckListConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports